import { defineStore, acceptHMRUpdate } from 'pinia'
// import { ApiGet, ApiPost, ApiPut } from 'boot/axios'
// --- --- --- Utilidades / Constants --- --- ---
// import { notifyApiMessages, validateForm  } from '@utils/Utilities'

export const useSettingsStore = defineStore('settings', {
  state: () => ({
    language: 'es', // 'es' | 'en-US',
    themeMode: 'light', // 'light' | 'dark' | 'auto',
  }),
  persist: true,
  actions: {

  },
  getters: {
    // nacionalidades: ( state ) => state.AppUser.data.nacionalidades.map( (n:any) => n.id),
  },
})

if( import.meta.hot ){
  import.meta.hot.accept(acceptHMRUpdate(useSettingsStore, import.meta.hot));
}
